import { Icon } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import { ExpandedButton } from '../Cockpit/Cockpit.styles'
import { Container } from './MapInfoWindowHeader.styles'

type MapInfoWindowHeaderProps = {
  onClose: VoidFunction
}

const MapInfoWindowHeader = ({ onClose }: MapInfoWindowHeaderProps) => {
  const { t } = useTranslation()

  return (
    <Container>
      <ExpandedButton title={t('system.close')} onClick={onClose}>
        <Icon iconName='Close' icSize='regular' />
      </ExpandedButton>
    </Container>
  )
}

export default MapInfoWindowHeader
